import React from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableContainer,
  Paper,
  Checkbox,
  TableCell,
} from '@mui/material';
import { DetailButton } from '../../../styles/StyledComponents';
import { PortalTableCell, PortalTableHead, PortalTableRow } from '../../../styles/portalListTable';
import ScoreBar from './ScoreBar';

const RequestsTable = ({
  paginatedUsers,
  selected,
  handleSelectAllClick,
  handleClick,
  isSelected,
  handleDetailsClick,
  containerSx,
}) => {
  return (
    <TableContainer component={Paper} sx={{ ...containerSx }}>
      <Table stickyHeader>
        <PortalTableHead>
          <TableRow>
            <TableCell padding="checkbox" style={{ width: '5%' }}>
              <Checkbox
                color="primary"
                indeterminate={selected.length > 0 && selected.length < paginatedUsers.length}
                checked={paginatedUsers.length > 0 && selected.length === paginatedUsers.length}
                onChange={handleSelectAllClick}
                inputProps={{
                  'aria-label': 'select all users',
                }}
              />
            </TableCell>
            <TableCell className="column-email">Email</TableCell>
            <TableCell className="column-date">Date</TableCell>
            <TableCell className="column-attempt">Attempt</TableCell>
            <TableCell className="column-score">Score</TableCell>
            <TableCell className="column-action" align="center">
              Action
            </TableCell>
          </TableRow>
        </PortalTableHead>
        <TableBody>
          {paginatedUsers.map((user) => {
            const isItemSelected = isSelected(user.id);
            return (
              <PortalTableRow
                onClick={(event) => handleClick(event, user.id)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                key={user.id}
                selected={isItemSelected}
              >
                <PortalTableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    checked={isItemSelected}
                    inputProps={{
                      'aria-labelledby': `enhanced-table-checkbox-${user.id}`,
                    }}
                  />
                </PortalTableCell>
                <PortalTableCell>{user.email}</PortalTableCell>
                <PortalTableCell>{user.date}</PortalTableCell>
                <PortalTableCell>{user.attempt}</PortalTableCell>
                <PortalTableCell>
                  <ScoreBar score={user.score} />
                </PortalTableCell>
                <PortalTableCell align="center">
                  <DetailButton
                    variant="outlined"
                    size="small"
                    onClick={() => handleDetailsClick(user.id, user.email)}
                  >
                    Details
                  </DetailButton>
                </PortalTableCell>
              </PortalTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RequestsTable;
